// extracted by mini-css-extract-plugin
export default {"details":"Collapse__details--gRGlr","content":"Collapse__content--BZ99i","icon":"Collapse__icon--L_i9H"};